module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.insertTable($event)
      }
    }
  }, [_c('label', [_vm._v("\n        " + _vm._s(_vm.$parent.locale["row count"]) + "\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rows),
      expression: "rows"
    }],
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "type": "number",
      "maxlength": "2",
      "min": "2",
      "max": "10"
    },
    domProps: {
      "value": (_vm.rows)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rows = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("\n        " + _vm._s(_vm.$parent.locale["column count"]) + "\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cols),
      expression: "cols"
    }],
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "type": "number",
      "maxlength": "2",
      "min": "2",
      "max": "10"
    },
    domProps: {
      "value": (_vm.cols)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cols = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$parent.locale.save))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-4dcd7f0a!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/src/modules/table/dashboard.vue
// module id = 651
// module chunks = 0